import { PaginatedApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import ComplaintMessage from '../../models/ComplaintMessage';


export interface ComplaintMessageState extends PaginatedApiState {
  complaintMessage?: ComplaintMessage[]
}

export default requestReducer<ComplaintMessageState>('COMPLAINT_MESSAGE')
